/** Shared vertical rhythm — balanced spacing on mobile, roomier on desktop */
export const SECTION_PY = 'pt-4 pb-4 md:pt-7 md:pb-7'

/** Marketing / content pages — same rhythm as homepage sections */
export const PAGE_SECTION_PY = SECTION_PY

/** Large hero bands (Premium, About, Achievements) */
export const PAGE_HERO_PY = 'py-4 md:py-6 lg:py-7'

/** Compact intro hero (PageIntroHero, blog headers) */
export const PAGE_INTRO_PY = 'py-3 md:py-4'

/** Compact intro hero — shared typography */
export const PAGE_INTRO_CRUMB = 'mb-2 text-[10px] md:text-[11px]'
export const PAGE_INTRO_BADGE =
  'inline-flex items-center gap-1 rounded-full border border-primary-200/80 bg-white/80 px-2 py-0.5 text-[9px] font-semibold uppercase tracking-wide text-primary-700 shadow-sm md:text-[10px]'
export const PAGE_INTRO_H1 =
  'mt-1.5 font-display text-lg font-bold leading-tight text-qbc-navy md:text-xl lg:text-2xl'
export const PAGE_INTRO_DESC =
  'mt-1.5 max-w-xl text-[12px] leading-snug text-neutral-600 md:text-[13px] lg:text-sm'
export const PAGE_INTRO_ACTIONS = 'mt-2 flex flex-wrap gap-1.5 sm:gap-2'
export const PAGE_INTRO_BTN = 'h-8 rounded-full px-3 text-[11px] sm:h-9 sm:px-4 sm:text-xs'

/** Large marketing hero — shared typography */
export const PAGE_HERO_BADGE =
  'inline-flex items-center gap-1.5 rounded-full border border-primary-200/80 bg-white/80 px-2.5 py-0.5 text-[10px] font-semibold uppercase tracking-wide text-primary-700 shadow-sm md:px-3 md:py-1 md:text-[11px]'
export const PAGE_HERO_H1 =
  'mt-2 font-display text-xl font-bold leading-tight text-qbc-navy md:text-2xl lg:text-3xl'
export const PAGE_HERO_DESC =
  'mt-2 max-w-xl text-[13px] leading-snug text-neutral-600 md:text-sm lg:text-base'
export const PAGE_HERO_ACTIONS = 'mt-3 flex flex-wrap items-center gap-2 md:mt-4 md:gap-3'
export const PAGE_HERO_BTN = 'h-9 rounded-full px-4 text-xs md:h-10 md:px-5 md:text-sm'

/** Bottom CTA strip above footer */
export const PAGE_CTA_PY = 'pb-6 pt-2 md:pb-8'

/** Space below section headings before content grids */
export const PAGE_SECTION_CONTENT_MT = 'mt-4 md:mt-5'

/** First section below hero — room for floating mobile search */
export const SECTION_PY_AFTER_HERO = 'pt-3 pb-4 md:pt-12 md:pb-7'

/** Sticky offsets for properties listing (header + filter bar stack) */
export const PROPERTY_FILTER_STICKY_TOP = 'top-14 md:top-[68px]'

/** Header (3.5rem/68px) + filter bar (py-2.5 + h-8 + border); -1px overlap avoids scroll seam */
export const PROPERTY_LISTING_HEADER_STICKY_TOP =
  'top-[calc(3.5rem+3.3125rem-1px)] md:top-[calc(68px+3.3125rem-1px)]'
